import { Route } from '@angular/router';
import { ENTITY_NO_ACCESS_PATH, ENTITY_RECORD_PATH } from './entity.record.contracts';
import { entityOperationRouteGuard } from './entity.operation.route.guard';

/**
 * One generic page route for every entity, on the primary outlet.
 *
 * `:slug` rather than the entity name because `ActivityEntityName` values are not URL-safe — see
 * `EntityManifest.slug`. An unknown or unslugged entity renders not-found inside the component rather
 * than failing to match, so a stale link gives a page instead of a router error.
 *
 * `:operation` mirrors `entityInspectorRoute` for the same reason it does there: one config covers
 * every operation, and moving between them stays a param change.
 */
export const entityRecordRoute: Route = {
  path: `${ENTITY_RECORD_PATH}/:slug/:operation`,
  loadComponent: () => import('./entity.record.page.component').then(m => m.EntityRecordPageComponent),
  // Refuses before anything mounts: a URL here is untrusted input. Redirects to the entity's board on a
  // denial, so a shared link that outlives someone's rights lands somewhere useful.
  canActivate: [entityOperationRouteGuard],
  // The side nav builds itself from the shell route's children and reads `data.title` /
  // `data.restrictions` unguarded, so a child with no `data` throws and takes the whole nav with it.
  data: { hidden: true, restrictions: [] },
};

/** Where `entityOperationRouteGuard` sends a denied full-page link. Two segments, so it never matches the record route. */
export const entityNoAccessRoute: Route = {
  path: ENTITY_NO_ACCESS_PATH,
  loadComponent: () => import('./entity.no.access.page.component').then(m => m.EntityNoAccessPageComponent),
  data: { hidden: true, restrictions: [] },
};
